import { render, staticRenderFns } from "./Salesforce-popin.vue?vue&type=template&id=f09e3a3a&scoped=true&"
import script from "./Salesforce-popin.vue?vue&type=script&lang=js&"
export * from "./Salesforce-popin.vue?vue&type=script&lang=js&"
import style0 from "./Salesforce-popin.vue?vue&type=style&index=0&id=f09e3a3a&prod&scoped=true&lang=scss&"
import style1 from "./Salesforce-popin.vue?vue&type=style&index=1&id=f09e3a3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09e3a3a",
  null
  
)

export default component.exports